import {Component, OnInit, model, Input, EventEmitter, Output} from '@angular/core';
import {AiPrompt} from 'app/Model/aiprompt';
import {InvoiceSettingDto} from 'app/Model/Dto/InvoiceSettingDto';
import {AiPromptsService} from 'app/Services/aiprompt.service';
import {InvoiceService} from 'app/Services/invoice.service';
import {LoginService} from 'app/Services/login.service';
import {SystemService} from 'app/Services/system.service';
import {TemplateService} from 'app/Services/template.service';
import {lastValueFrom} from 'rxjs';


@Component({
  selector: 'description-wizard',
  templateUrl: './description-wizard.component.html'
})
export class DescriptionWizardComponent implements OnInit {
  @Input() prompt: AiPrompt;
  @Output() promptChange = new EventEmitter<AiPrompt>();

  prompts: AiPrompt[] = [];

  promptResult: string = null;
  editorVisible = false;
  loading = false;

  invoiceSetting: InvoiceSettingDto = new InvoiceSettingDto();

  constructor(
    public loginService: LoginService,
    public promptService: AiPromptsService,
    public systemService: SystemService,
    public templateService: TemplateService,
    public invoiceServce: InvoiceService
  ) {
  }

  async ngOnInit() {
    this.promptService.getAll(this.loginService.currentCustomer.id).then(x => {
      this.prompts = x;
    });
    lastValueFrom(this.invoiceServce.GetInvoiceSetting(this.loginService.currentCustomer.id)).then(x => this.invoiceSetting = x);
  }


  openEditor() {
    this.editorVisible = true;
  }

  async deleteConfig() {
    await this.promptService.delete(this.prompt.id, this.loginService.currentCustomer.id);
    this.prompts = await this.promptService.getAll(this.loginService.currentCustomer.id);
  }

  async openCreate() {
    let newPrompt = await this.promptService.create(
      new AiPrompt(null, 'Neuer Prompt'),
      this.loginService.currentCustomer.id
    );
    this.prompts = await this.promptService.getAll(this.loginService.currentCustomer.id);
    this.openEditor();
  }

  onSaveEdit = async () => {
    if (!this.prompt) return;
    try {
      await this.promptService.update(this.prompt, this.loginService.currentCustomer.id);
      this.prompts = await this.promptService.getAll(this.loginService.currentCustomer.id);
    } catch (err) {
      console.error(err);
    }
    this.editorVisible = false;
  };

  onCancelEdit = () => {
    this.editorVisible = false;
  };

  selectedPromptChanged() {
    this.promptChange.emit(this.prompt);
  }
}
